<template>
    <div>
        <v-tabs v-model="tab">
            <v-tab v-for="(locale, index) in locales" :key="`tab-${index}`">
                {{ locale.full_name }}
                {{ locale.required == true ? "(*)" : null }}
            </v-tab>
            <v-tab-item
                v-for="(locale, index) in locales"
                :key="`tab-item-${index}`"
            >
                <v-text-field
                    v-model="item[locale.short_name]"
                    :error-messages="errors"
                    filled
                    :placeholder="placeholder"
                ></v-text-field>
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                default: function () {
                    return {};
                },
                required: true,
            },
            label: {
                type: String,
                default: "name",
                required: false,
            },
            name: {
                type: String,
                default: "name",
                required: false,
            },
            errors: {
                type: Array,
                required: false,
            },
            valid: {
                type: Boolean,
                required: false,
            },
            placeholder: {
                type: String,
                required: false,
            },
        },
        data() {
            return {
                tab: 0,
            };
        },
        watch: {
            item: {
                handler() {
                    this.$emit("input", this.item);
                },
                immediate: true,
            },
        },
        computed: {
            item() {
                return this.value || {};
            },
            locales() {
                return [
                    {
                        full_name: "English",
                        short_name: "en",
                        required: true,
                    },
                    {
                        full_name: "ភាសាខ្មែរ",
                        short_name: "km",
                        required: false,
                    },
                    {
                        full_name: "Francais",
                        short_name: "fr",
                        required: false,
                    },
                    {
                        full_name: "Chinese",
                        short_name: "zh",
                        required: false,
                    },
                ];
            },
        },
    };
</script>